const budget = {
  id: "budget",
  title: "Budget Transparency & Commercial Structure",
  questions: [
    {
      question: "How do you structure your event or travel budget?",
      answer: "We provide a detailed, line-by-line cost breakdown covering stay, travel, production, logistics, and management fees for complete clarity."
    },
    {
      question: "Are there any hidden charges?",
      answer: "No. We operate with complete transparency. All inclusions and exclusions are clearly defined in the proposal, and we charge only a pre-agreed agency fee — which is separately and clearly mentioned upfront."
    },
    {
      question: "How accurate is the initial budget estimate?",
      answer: "Our estimates are prepared using verified vendor quotations and real-time destination pricing to ensure minimal variance during final execution."
    },
    {
      question: "Can the budget be customized as per our target spend?",
      answer: "Yes. We design scalable concepts that align with your defined budget range without compromising execution quality."
    },
    {
      question: "How do you help optimize overall event cost?",
      answer: "Through negotiated hotel contracts, bulk vendor rates, in-house production coordination, and smart logistics planning."
    },
    {
      question: "What are the payment terms and milestones?",
      answer: "Payments are structured in phases — advance confirmation, pre-event settlement, and final reconciliation after execution."
    },
    {
      question: "How do you manage budget control during execution?",
      answer: "We operate with pre-approved cost sheets and vendor confirmations to prevent overspending on-ground."
    },
    {
      question: "Will we receive a final expense reconciliation report?",
      answer: "Yes. A detailed post-event financial summary is shared for transparency and internal audit purposes."
    },
    {
      question: "How do cancellations or modifications affect the budget?",
      answer: "All cancellation terms are clearly defined upfront as per vendor policies, ensuring no last-minute financial surprises."
    },
    {
      question: "Why should we not book directly with hotels or vendors?",
      answer: "We leverage negotiated rates, bundled services, and centralized coordination — saving cost while reducing execution risk."
    }
  ]
};

export default budget;
